import React from 'react';
import { CheckIcon, LockIcon, ZapIcon } from 'lucide-react';
import { finalQuestions, pricingAnchor } from '../data/content';
import { Button } from './ui/Button';
export function FinalCta() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-64" data-mp="19f7ex64rcfdw">
      <div className="mx-auto max-w-3xl text-center" data-id="element-65" data-mp="19cuqqb8ep8se">
        <h2 className="text-2xl font-black uppercase leading-tight text-blue-950 md:text-4xl" data-id="element-66" data-mp="15caqgysjdp21">
          A clear decision for every category.
        </h2>
        <p className="mt-4 text-base font-bold text-slate-600 md:text-lg" data-id="element-67" data-mp="1ee1wk4qznxwf">
          You do not need another random list of things to remove. You need a system that helps
          you answer:
        </p>

        <ul className="mx-auto mt-5 max-w-lg space-y-2 text-left" data-id="element-68" data-mp="1o3vahcelsp3u">
          {finalQuestions.map(question => <li key={question} className="flex items-center gap-3 rounded-xl bg-slate-50 px-4 py-2.5 text-base font-black text-blue-950" data-id="element-69" data-mp="2233au8mi639m">
              <CheckIcon className="h-5 w-5 shrink-0 text-yellow-700" aria-hidden="true" data-id="element-70" data-mp="n5m887qsge4i" />
              {question}
            </li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-2xl text-sm font-semibold leading-relaxed text-slate-600 md:text-base" data-id="element-71" data-mp="s57g57nxrwtd">
          With CLEAR THE CLUTTER™, you open the category, follow the questions, choose the next
          action, and move forward.
        </p>

        <div className="mt-8 space-y-1 text-3xl font-black uppercase leading-none text-blue-950 md:text-5xl" data-id="element-72" data-mp="165044v82vyxn">
          <p data-id="element-73" data-mp="1b2ru3jp5xaz7">One item.</p>
          <p data-id="element-74" data-mp="1b1ywb886lvt7">One decision.</p>
          <p data-id="element-75" data-mp="1b16zxv6rfu1v">
            <span className="rounded bg-amber-300 px-2" data-id="element-76" data-mp="1fua04m61m1r1">One destination.</span>
          </p>
        </div>

        <div className="mt-9" data-id="element-77" data-mp="1kt3aw6ty3eni">
          <Button href={pricingAnchor} className="w-full text-sm md:w-auto md:text-lg" data-id="element-78" data-mp="1ksbhn2ntlt0e">
            🏠 I want Clear the Clutter™ →
          </Button>
        </div>

        <p className="mt-4 text-sm font-bold text-slate-600" data-id="element-79" data-mp="1ttrox1jc9f0e">
          5 Complete Volumes + 5 Practical Bonuses · Digital Access · 7-Day Guarantee
        </p>
        <div className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-slate-500 md:text-sm" data-id="element-80" data-mp="3qux84gvofoxf">
          <span className="flex items-center gap-1" data-id="element-81" data-mp="3hl6rarsgke7">
            <ZapIcon className="h-3.5 w-3.5 text-yellow-700" data-id="element-82" data-mp="3j60iy6a3zb0" /> Digital access in minutes
          </span>
          <span className="flex items-center gap-1" data-id="element-83" data-mp="3uupo3enegxct">
            <LockIcon className="h-3.5 w-3.5 text-yellow-700" data-id="element-84" data-mp="df9d6xyrbgc7" /> Secure payment
          </span>
        </div>
      </div>
    </section>;
}